// native
import { Injectable } from '@angular/core';

// service
import { LocalStorageService } from './local-storage.service';

// constants
import { EXPANDED_SHARED_COLLECTIONS_KEY, EXPANDED_LISTS_KEY, EXPANDED_PRIVATE_COLLECTION_KEY } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  isPrivateCollectionExpanded: boolean;
  expandedSharedCollections: { [key: string]: boolean; };
  expandedLists: { [key: string]: boolean; };

  constructor(
    private localStorageService: LocalStorageService
  ) {
    const isPrivateCollectionExpanded = this.localStorageService.getByKey(EXPANDED_PRIVATE_COLLECTION_KEY);
    this.isPrivateCollectionExpanded =  isPrivateCollectionExpanded === null ? true : isPrivateCollectionExpanded;

    this.expandedSharedCollections = this.localStorageService.getByKey(EXPANDED_SHARED_COLLECTIONS_KEY) || {};
    this.expandedLists = this.localStorageService.getByKey(EXPANDED_LISTS_KEY) || {};
  }

  setExpandedPrivateCollection(isExpanded: boolean) {
    this.isPrivateCollectionExpanded = isExpanded;

    this.localStorageService.save(EXPANDED_PRIVATE_COLLECTION_KEY, isExpanded);
  }

  setExpandedSharedCollections(collectionId: string, isExpanded: boolean) {
    Object.keys(this.expandedSharedCollections).forEach(storedCollectionId => {
      this.expandedSharedCollections[storedCollectionId] = false;
    });

    this.expandedSharedCollections[collectionId] = isExpanded;

    this.localStorageService.save(EXPANDED_SHARED_COLLECTIONS_KEY, this.expandedSharedCollections);
  }

  setExpandedLists(listId: string, isExpanded: boolean) {
    this.expandedLists[listId] = isExpanded;

    this.localStorageService.save(EXPANDED_LISTS_KEY, this.expandedLists);
  }

  isSharedCollectionExpanded(collectionId: string): boolean {
    return this.expandedSharedCollections[collectionId];
  }

  isListExpanded(listId: string): boolean {
    return this.expandedLists[listId];
  }
}